export const isMobile = (typeof window !== 'undefined') && window.innerWidth <= 500 ? true : false;

